import { gql } from 'apollo-boost';

export const SEARCH_QUERY = gql`
query search(
    $types: [ES_SearchOptionsTypesEnum!], 
    $query: String, 
    $page: Int, 
    $limit: Int, 
    $sort: ES_SearchOptionsSortEnum, 
    $order: ES_SearchOptionsOrderEnum, 
    $brandIds: [UUID!],
    $courseIsIlt: Boolean
    $personId: UUID, 
    $localeCode: ES_SearchOptionsLocaleCodeEnum, 
    $sortObject: [ES_SearchOptionsSortObjectEnum!], 
    $categoryId: UUID, 
    $ids: [UUID!]) {
    search(searchOptions: {
      types: $types, 
      query: $query, 
      page: $page, 
      limit: $limit, 
      brandIds: $brandIds,
      sort: $sort, 
      order: $order, 
      personId: $personId, 
      localeCode: $localeCode, 
      sortObject: $sortObject,
      courseIsIlt: $courseIsIlt
      categoryId: $categoryId, 
      _ids: $ids, 
      isPublished: true}) {
      totalCount
      searchOptions {
        page
        limit
      }
      edges {
        weight
        node {
          __typename
          ... on ES_Curriculum {
            curriculumId
            name {
              locale
              content
            } 
            description {
              locale
              content
            }
            thumbnailImage {
              url
            }
            heroImage {
              url
            }
            bannerImage {
              url
            }
            courses {
              courseId
              name {
                locale
                content
              }
              description {
                locale
                content
              }
              thumbnailImage {
                url
              }
              lxp {
                relatedResourceBrandIds
                relatedResourceLocaleIds
                relatedResourceCompanyRelationshipIds,
                relatedResourceProductIds
                prerequisiteSet {
                  prerequisiteSetId
                  type
                  operator
                  prerequisites {
                    prerequisiteId
                    objectId
                    name {
                      locale
                      content
                    }
                  }                
                }
                courseCertificates {
                  courseCertificateId
                  brand {
                    name
                  }
                }
                tags {
                  name
                }
              }
            }
            lxp {
              relatedResourceBrandIds
              relatedResourceLocaleIds
              relatedResourceIds
              relatedResourceCompanyRelationshipIds,
              relatedResourceProductIds
              categories {
                categoryId
                brand {
                  brandId
                  name
                }
                name {
                  locale
                  content
                }
                description {
                  locale
                  content
                }
              }              
              prerequisiteSet {
                prerequisiteSetId
                type
                operator
                prerequisites {
                  prerequisiteId
                  objectId
                  name {
                    locale
                    content
                  }
                }                
              }
              tags {
                name
              }
            }
          }
          ... on ES_Course {
            courseId
            name {
              locale
              content
            }
            curriculumIds
            description {
              locale
              content
            }
            thumbnailImage {
              url
            }
            heroImage {
              url
            }
            bannerImage {
              url
            }
            isIlt
            ratingAverage
            learningObjects {
              learningObjectId
              duration
              format
              name {
                  locale
                  content
              }
              assets {
                  asset {
                      mimetype
                      url
                      lxpFileId
                      iltId
                  }
              }
              description {
                  locale
                  content
              }
            }
            resources {
                updatedAt
                createdAt
                isPublished
                resourceId
                resourceLocalizations {
                    name
                    description
                    localeCode
                    resourceFile {
                        resourceFileId
                        lxpFile {
                            filename
                            mimetype
                        }
                        genericFile {
                            filename
                            mimetype
                        }
                    }
                }
            }
            lxp {
              relatedResourceBrandIds
              relatedResourceLocaleIds
              relatedResourceCompanyRelationshipIds,
              relatedResourceProductIds
              prerequisiteSet {
                prerequisiteSetId
                type
                operator
                prerequisites {
                  prerequisiteId
                  objectId
                  name {
                    locale
                    content
                  }
                }                
              }
              courseCertificates {
                courseCertificateId
                brand {
                  name
                }
              }
              tags {
                name
              }
            }
          }
          ... on ES_ComponentListSet {
            componentListSetId
            name {
              locale
              content
            }
            description {
              locale
              content
            }
            type
            createdAt
            componentLists {
              componentListId
              type
              uuids
            }
          }
          ... on ES_Category {
              categoryId
              name {
                locale
                content
              }
              description {
                locale
                content
              }
              courseIds
              curriculumIds
              sortOrder
              createdAt
              updatedAt  
              publishedAt
          }
          ... on ES_Resource {
            resourceId
            name {
              locale
              content
            }
            description {
              locale
              content
            }
            isPublished
            resourceLocalizations {
              name
              description
              localeCode
              resourceFile {
                resourceFileId
                genericFile {
                  filename
                  mimetype
                }
                lxpFile {
                  filename
                  mimetype
                }
              }
              isDefault
            }
            lxp {
              relatedResourceBrandIds
              relatedResourceLocaleIds
              relatedResourceCompanyRelationshipIds,
              relatedResourceProductIds
              tags {
                name
              }
            }
          }
          ... on ES_Notification {
            notificationId
            name {
              locale
              content
            }
            description {
              locale
              content
            }
            isSticky
            isPublished
            isFeatured
            publishedAt
            weight
          }
        }
      }
    }
  }
`;

// ES_SearchOptionsTypesEnum: ['curricula','courses','resources']
// ES_SearchOptionsSortEnum: ['name', 'createdAt', 'updatedAt']
// ES_SearchOptionsOrderEnum: ['asc', 'desc']